declare var bootstrap: any;
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SharedService } from '../Services/shared.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { CartService } from '../Services/cart.service';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { API_End_Point } from '../Services/API_End_Point';
import { Dialog } from '@angular/cdk/dialog';
import { DialogAddSiblingComponent } from './dialog-add-sibling/dialog-add-sibling.component';
import { DialogMychildComponent } from '../Modules/Home/Components/dialog-mychild/dialog-mychild.component';
import { distinctUntilChanged } from 'rxjs';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, ReactiveFormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  PasswordForm!: FormGroup;
  PREP_UserInfo: any;
  cartItemCount: number = 0;

  constructor(
    public _svc: SharedService,
    private _router: Router,
    private _cart: CartService,
    private fb: FormBuilder,
    private _dialog: Dialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    this._svc.get_Login_Status().pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))).subscribe(x => {
      this.PREP_UserInfo = x;

      this._svc.getUserInfo().subscribe(userInfo => {
        if (userInfo) {
          this.PREP_UserInfo = userInfo;
        }
      });
      debugger;
      // if (this.PREP_UserInfo != null) {
      //   if (this.PREP_UserInfo.child == null) {
      //     this._dialog.open(DialogMychildComponent, {
      //       data: null
      //     }).closed.subscribe((res: any) => {

      //       if (res.result == "Success") {
      //       }
      //     });
      //   }
      // }

    })



  }
  ngOnInit() {
    this._cart.cartItems().subscribe(x => {
      this.cartItemCount = this._cart.cartItemCount();
    })

    this.PasswordForm = this.fb.group({
      emailId: [''],
      Password: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(8)]],
    },
      {
        validators: this.matchPasswordsValidator
      });
  }

  ngAfterViewInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        const script = document.createElement('script');
        script.src = '/assets/js/all-instructor-custom.js'; // path to your JS
        script.async = true;
        document.body.appendChild(script);
      }, 1000)

    }
  }
  Logout() {
    this._svc.logout(null);
  }
  openProfileModal() {
    const modalElement = document.getElementById('profileModal');
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }

  ChangePasswordModal() {
    const modalElement = document.getElementById('ModalPasswordChange');
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }

  ChangePassword() {
    if (this.PREP_UserInfo) {
      this.PasswordForm.value.emailId = this.PREP_UserInfo.emailId;
    }
    this._svc.POST(this.PasswordForm.value, API_End_Point.ChangePassword).subscribe(
      (res: any) => {
        this._svc.Notification(res.result, res.message);
        this.PasswordForm.reset();
      },
    );
  }
  matchPasswordsValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const Password = group.get('Password')?.value;
    const confirmpassword = group.get('confirmPassword')?.value;
    return Password === confirmpassword ? null : { passwordsMismatch: true };
  };



  Switch_Child() {
    this._dialog.open(DialogMychildComponent, {
      data: null
    }).closed.subscribe((res: any) => {

      if (res.result == "Success") {
      }
    });
  }

  editProfile()
  {
    
  }
}